export enum PaymentViews {
  CREDIT_CARD = 'CREDIT_CARD',
  CREDENZA_BALANCE = 'CREDENZA_BALANCE',
}
